let elements = {
  mainImage: {
    imagePath: 'games/page001_game3/img/bcg.jpg',
    pos: {
      x: 0,
      y: 0,
    },
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  fields: [
    {
      pos: {
        y: 265,
        x: 1008,
      },
      width: 70,
      height: 70,
      background: 'transparent',
      // images: [
      //   {
      //     // src: 'games/page001_game3/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html:
      //   '<p style="padding-top: 100px; font-size: 28px">Monitor znajduje się w odległości wyciągniętej ręki dziecka.</p>',
      audio: {
        src: 'games/page001_game3/audio/z1c3-4.mp3',
        volume: 1,
      },
    },
    {
      pos: {
        y: 535,
        x: 1091,
      },
      width: 70,
      height: 70,
      // height: 90,
      background: 'transparent',
      // images: [
      //   {
      //     src: 'games/page001_game3/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Dłonie leżą swobodnie na klawiaturze.</p>',
      audio: {
        src: 'games/page001_game3/audio/z1c3-3.mp3',
        volume: 1,
      },
    },
    {
      pos: {
        y: 487,
        x: 181,
      },
      width: 70,
      height: 70,
      // height: 90,
      // images: [
      //   {
      //     src: 'games/page001_game3/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Plecy są wyprostowane i przylegają do oparcia.</p>',
      background: 'transparent',
      audio: {
        src: 'games/page001_game3/audio/z1c3-1.mp3',
        volume: 1,
      },
    },
    {
      pos: {
        y: 977,
        x: 451,
      },
      width: 70,
      height: 70,
      // height: 90,
      background: 'transparent',
      // images: [
      //   {
      //     src: 'games/page001_game3/img/dzwiek.png',
      //     pos: {
      //       y: 0,
      //       x: 100,
      //     },
      //     width: 100,
      //     height: 100,
      //   },
      // ],
      // html: '<p style="padding-top: 100px; font-size: 28px">Stopy spoczywają na podłodze.</p>',
      audio: {
        src: 'games/page001_game3/audio/z1c3-2.mp3',
        volume: 1,
      },
    },
  ],
  // mbAudioItemData: [
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 223,
  //       x: 464,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 512,
  //       x: 574,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 333,
  //       x: 1344,
  //     },
  //     unit: 'px',
  //   },
  //   {
  //     src: 'games/page001_game3/audio/z1c3-1.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'black',
  //     },
  //     width: '90px',
  //     height: '90px',
  //     pos: {
  //       y: 773,
  //       x: 1214,
  //     },
  //     unit: 'px',
  //   },
  // ],
};

export default elements;
